import { type CohortDslLegacy } from '@verantos-dev/types-cohorts';

/**
 *
 * @param {CohortDsl} cohortDsl - The cohort definition DSL query
 * @param {boolean} returnMockedCompleteQuery - Whether or not to return mocked data to form a complete query
 *   This param can be used for testing purposes to generate a complete query even if the dsl doesn't have a section
 * @returns {string} - The full DSL query
 */
export const getFullDslQueryString = (
  cohortDsl: CohortDslLegacy,
  returnMockedCompleteQuery = false
): string => {
  let fullDslQuery = '';

  // Add inclusion criteria
  if (cohortDsl.inclusionCriteria.length > 0) {
    fullDslQuery += 'INCLUDE ( ';
    cohortDsl.inclusionCriteria.forEach((criteria, index) => {
      fullDslQuery += (index ? ', ' : '') + `SUBJECTS_VARIABLE::"${criteria.value}"`;
    });
    fullDslQuery += ' ) ;\n';
  } else if (returnMockedCompleteQuery) {
    fullDslQuery += `INCLUDE ( SUBJECTS_VARIABLE::"MOCKED_INCLUDE" ) ;\n`;
  }

  // Add exclusion criteria
  if (cohortDsl.exclusionCriteria.length > 0) {
    fullDslQuery += 'EXCLUDE ( ';
    cohortDsl.exclusionCriteria.forEach((criteria, index) => {
      fullDslQuery += (index ? ', ' : '') + `SUBJECTS_VARIABLE::"${criteria.value}"`;
    });
    fullDslQuery += ' ) ;\n';
  } else if (returnMockedCompleteQuery) {
    fullDslQuery += `EXCLUDE ( SUBJECTS_VARIABLE::"MOCKED_EXCLUDE" ) ;\n`;
  }

  // Add study period restrictions
  if (cohortDsl.studyPeriodRestrictions?.length > 0) {
    cohortDsl.studyPeriodRestrictions.forEach(({ value }) => {
      fullDslQuery += `${value}\n`;
    });
  }

  // Add subject variables
  if (cohortDsl.subjectVariables.length > 0) {
    cohortDsl.subjectVariables.forEach(({ value }) => {
      fullDslQuery += value;
    });
  } else if (returnMockedCompleteQuery) {
    // Add fake query if there's no subject variable
    fullDslQuery += 'SUBJECTS_VARIABLE::"MOCKED" = PERSON (  ) ;\n';
  }

  // Add index date
  if (cohortDsl.indexDate) {
    fullDslQuery += cohortDsl.indexDate.value + '\n';
  }

  // add derived events
  cohortDsl.derivedEvents.forEach(({ value }) => {
    fullDslQuery += value;
  });

  // Add simple events
  cohortDsl.simpleEvents.forEach(({ value }) => {
    fullDslQuery += value;
  });

  return fullDslQuery;
};
